import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23f9f7aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Select Microphone", -1))
const _hoisted_4 = { class: "button-group" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Ok")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Volume = _resolveComponent("Volume")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: ".call" }, [
      _hoisted_2
    ])),
    _hoisted_3,
    _createVNode(_component_Select, {
      active: _ctx.active,
      "onUpdate:active": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
        _ctx.changeMicrophone
      ],
      size: "s",
      options: _ctx.mics.list
    }, null, 8, ["active", "onUpdate:active", "options"]),
    (_ctx.audioWorkletDetected)
      ? (_openBlock(), _createBlock(_component_Volume, {
          key: 0,
          inputId: _ctx.active
        }, null, 8, ["inputId"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        mode: "primary",
        size: "s",
        width: "fill-container",
        onClick: _ctx.setNewMicrophone
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        mode: "secondary",
        size: "s",
        width: "fill-container",
        onClick: _ctx.closeSettings
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}